module.exports = __webpack_public_path__ + "static/banner-1e3dd0d865dc64a474cf2f0bc6639b0a.png";